export default "__VITE_ASSET__a7504263__"